import Button from '../../components/Button/Button';
import Stats from '../../components/Stats/Stats';
import styles from './PageHome.module.css'
import { Link } from 'react-router-dom';

function PageHome() {
  return (
    <div className={styles.PageHome}>
      <div className={styles.CodeAblazeTitle}>
        <h1>Code Ablaze</h1>
        <h2>Learn coding, the fun way.</h2>
      </div>
      <div className={styles.ContentDiv}>
        <div className={styles.DescriptionDiv}>
          Code Ablaze offers an exciting in-person program in San Jose, California where elementary and middle school students can learn coding in a fun and interactive way. We are a volunteer-based organization led by high schoolers with experience in computer programming. Our program is designed to ignite the "blaze" and passion for computer science among young minds, equipping students with valuable coding skills. Join us and embark on a journey to explore the world of programming!
          <div className={styles.Spacing} />
          <Link to="/about" className={styles.LearnMoreBtn}>
            <Button text="Learn More" />
          </Link>
        </div>
      </div>
      <Stats />
    </div>
  );
}

export default PageHome;